import type { Dictionnaire } from '../type';

export const commun: Dictionnaire['commun'] = {
  annuler: 'Cancel',
  oui: 'Yes',
  actions: 'Actions',
  confirmer: 'Confirm',
  retour: 'Back',
  reessayer: 'Try again',
  pleinEcran: 'Full-screen photo',
  fermer: 'Close',
  enLigne: 'Online',
  erreur: 'Something went wrong',
  serveur: {
    refuse: "This message doesn't follow the community rules.",
    invalide: 'Invalid message',
    accesRefuse: 'Access denied.',
    indisponible: "Can't publish right now. Try again in a moment.",
  },
  choisisUnSpot: 'Choose a spot first',
  membreInconnu: 'Unknown member',
  quelquun: 'Someone',
  nonConfigure: "Firebase isn't configured. Fill in client/.env.local (see client/.env.example).",
  unInstant: 'One moment…',
  envoi: 'Sending…',
  uneLangue: 'Choose at least one language.',
};
